// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rUoJ","option":"styles_option__zA_xx","selected":"styles_selected__3tWCh"};